import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from "@/lib/utils";
import { cva } from "class-variance-authority";
import { debounce } from "lodash";
import { forwardRef, useEffect, useRef } from "react";
const textFieldVariants = cva([
    "w-full rounded-md border border-gray-200 bg-white text-primary outline-none text-base font-normal p-3 h-12 resize-none overflow-hidden",
    "hover:border-gray-300 focus:border-gray-700",
    "placeholder:text-gray-900/50",
    "disabled:text-muted disabled:border-gray-100 disabled:bg-gray-50"
], {
    variants: {
        error: {
            true: [
                "border-status-error bg-red-0",
                "hover:border-status-error",
                "focus:border-status-error"
            ]
        }
    }
});
const helperTextVariants = cva("typo-body2 text-secondary ml-2 mt-1", {
    variants: {
        error: {
            true: "text-status-error"
        }
    }
});
const TextField = /*#__PURE__*/ forwardRef((param, ref)=>{
    let { className , error , helperText , label , ...props } = param;
    const textareaRef = useRef(null);
    const adjustHeight = (textarea)=>{
        textarea.style.height = "auto";
        textarea.style.height = "".concat(textarea.scrollHeight, "px");
    };
    const handleInput = (e)=>{
        adjustHeight(e.target);
        if (props.onChange) {
            props.onChange(e);
        }
    };
    useEffect(()=>{
        const textarea = textareaRef.current;
        if (!textarea) return;
        const handleResize = debounce(()=>{
            adjustHeight(textarea);
        }, 100);
        window.addEventListener("resize", handleResize);
        return ()=>{
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex flex-col",
        children: [
            label && /*#__PURE__*/ _jsx("label", {
                className: "block mb-2 typo-subtitle1",
                children: label
            }),
            /*#__PURE__*/ _jsx("textarea", {
                ref: (node)=>{
                    textareaRef.current = node;
                    if (typeof ref === "function") {
                        ref(node);
                    } else if (ref) {
                        ref.current = node;
                    }
                },
                className: cn(textFieldVariants({
                    error
                }), className),
                onInput: handleInput,
                rows: 1,
                ...props
            }),
            helperText && /*#__PURE__*/ _jsx("div", {
                className: cn(helperTextVariants({
                    error
                })),
                children: helperText
            })
        ]
    });
});
TextField.displayName = "TextField";
export default TextField;
